<template>
  <el-dialog :title="modalTitle" :visible.sync="show" width="700px" append-to-body @close="cancelModal">
    <div class="modal_content sporter_content_box">
      <div class="add_sporter_box">
        <!-- <div class="title">选择人员</div> -->
        <div class="sporter_content flex-row justify-between">
          <div class="leftBar">
            <div class="flex-column">
              <div class="topHeight">
                <el-input
                  class="select_pop_search"
                  placeholder="输入关键字进行筛选"
                  v-model="filterText"
                  @change="$forceUpdate()"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"
                     style="font-size:18px; margin-top: -2px;"></i>
                </el-input>
              </div>
              <div class="heightScroll" >
                <el-tree
                  ref="tree"
                  node-key="id"
                  show-checkbox
                  default-expand-all
                  class="filter-tree"
                  :data="treeList"
                  :props="defaultProps"
                  :check-strictly="!mpl"
                  :filter-node-method="filterNode"
                  :default-checked-keys="checkedKeys"
                  @check="getCheck">
                </el-tree>
              </div>
            </div>
          </div>
          <div class="rightBar">
            <div class="header flex-row justify-between align-center topHeight">
              <span class="flxL">已选{{ whoMember.length }}</span>
              <span class="flxR pointer" @click="delMemberAll">清空</span>
            </div>
            <div class="heightScroll">
              <div class="selected_list">
                <div
                  class="selected_item flex-row justify-between align-center"
                  v-for="item in whoMember"
                  :key="item.id"
                >
                  <span>{{ item.name }}</span>
                  <i class="el-icon-close" @click="delMember(item.id)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelModal">取消</el-button>
      <el-button type="primary" @click="confirmSporter">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    keys: [],
    peoples: [],
    dataList: [],
    disMember: [],
    modalTitle: {
      type: String,
      default: "选择人员",
    },
    needValues:  {
      type: Boolean,
      default: false,
    },
    modalVisible: {
      type: Boolean,
      default: false,
    },
    mpl: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      checkAll: false,
      expandAll: true,
      checkedKeys: [],
      whoMember: [{name: '111'}],
      treeList: [],
      expandedKeys: [],
      show: false,
      filterText:''
    };
  },
  watch: {
    modalVisible(newV) {
      if (newV) {
        console.log(newV);
        this.show = true;
        // console.log(this.dataList);
        let dataList = this.convertToTree(this.dataList);
        this.$nextTick(() => {
          // console.log(this.disMember);
          this.treeList = dataList;
          this.expandedKeys = dataList;
          this.checkedKeys = this.keys;
          if(this.disMember && this.disMember.length) {
            for (let i = 0; i < this.treeList.length; i++) {
              let team = this.treeList[i];
              for (let j = 0; j < team.children.length; j++) {
                let group = team.children[j];
                for (let k = 0; k < group.children.length; k++) {
                  let user = group.children[k];
                  if(this.disMember.indexOf(user.id) > -1) {
                    // user.disabled = true
                    this.$set(this.treeList[i].children[j].children[k],'disabled',true)
                  }
                }
              }
            }
          }
          console.log(this.treeList);
          this.$forceUpdate()
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(this.checkedKeys, true)
            this.whoMember = this.$refs.tree.getCheckedNodes().filter(item => typeof item.id == 'number');
          })
        });
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted() {},
  methods: {
    convertToTree(data) {
      // 创建根节点
      const root = [];

      // 处理团队及其下属小组和用户
      if (data.teams && Array.isArray(data.teams)) {
        data.teams.forEach(team => {
          const teamNode = {
            id: `t${team.teamId}`,
            name: team.teamName || '',
            children: []
          };

          // 处理团队内的小组
          if (team.groups && Array.isArray(team.groups)) {
            team.groups.forEach(group => {
              const groupNode = {
                id: `g${group.groupId}`,
                name: group.groupName || '',
                children: []
              };

              // 处理小组内的用户
              if (group.users && Array.isArray(group.users)) {
                group.users.forEach(user => {
                  const userNode = {
                    id: user.userId,
                    name: user.userName || '',
                    userName: user.userName || '',
                    headImageUrl: user.headImageUrl
                  };
                  groupNode.children.push(userNode);
                });
              }

              teamNode.children.push(groupNode);
            });
          }

          // 处理直接属于团队的用户（无小组）
          if (team.users && Array.isArray(team.users)) {
            team.users.forEach(user => {
              const userNode = {
                id: user.userId,
                name: user.userName || '',
                userName: user.userName || '',
                headImageUrl: user.headImageUrl
              };
              teamNode.children.push(userNode);
            });
          }

          root.push(teamNode);
        });
      }

      // 处理独立的小组（不在任何团队下）
      if (data.groups && Array.isArray(data.groups)) {
        data.groups.forEach(group => {
          const groupNode = {
            id: `g${group.groupId}`,
            name: group.groupName || '',
            children: []
          };

          if (group.users && Array.isArray(group.users)) {
            group.users.forEach(user => {
              const userNode = {
                id: user.userId,
                name: user.userName || '',
                userName: user.userName || '',
                headImageUrl: user.headImageUrl
              };
              groupNode.children.push(userNode);
            });
          }

          root.push(groupNode);
        });
      }

      // 处理独立的用户（无团队、无小组）
      if (data.users && Array.isArray(data.users)) {
        data.users.forEach(user => {
          const userNode = {
            id: user.userId,
            name: user.userName || '',
            userName: user.userName || '',
            headImageUrl: user.headImageUrl
          };
          root.push(userNode);
        });
      }

      return root;
    },
    // 成员--删除
    delMember(id) {
      console.log(id);
      this.whoMember = this.whoMember.filter(item => item.id != id);
      this.checkedKeys = this.whoMember.map(item => item.id)
      this.checkAll = false;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkedKeys, true)
      })
    },
    // 成员--清空
    delMemberAll() {
      this.whoMember = [];
      this.checkedKeys = [];
      this.checkAll = false;
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([], true)
      })
    },
    // 成员--确认弹框
    confirmSporter() {
      // console.log(this.mpl);
      console.log(this.whoMember);
      if(this.needValues && !this.whoMember.length) {
        this.$message.error('人员不能为空!')
        return
      }
      if(this.whoMember.length && this.whoMember.length > 1 && !this.mpl) {
        this.$message.error('只能单选!')
        return
      }
      this.show = false;
      this.$emit("transmit", this.whoMember);
    },
    cancelModal() {
      this.show = false;
      this.$emit("transmit", "");
    },
    getCheck(node,list) {
      console.log(node,list)
      if(!this.mpl) {
        if (list.checkedKeys.length == 2) {
          this.$refs.tree.setCheckedKeys([node.id]);
        }
      }
      this.whoMember = this.$refs.tree.getCheckedNodes().filter(item => typeof item.id == 'number');
      this.checkedKeys = this.whoMember.map(item => item.id)
      this.$forceUpdate()
    },
    filterNode(value, data) {
      // console.log(value);
      // console.log(data);
      return data.name.indexOf(value) > -1
    },
  },
};
</script>

<style lang="less" scoped>
.modal_content {
  .add_sporter_box {
    width: 100%;
    .topHeight {
      padding: 0 10px;
      height: 50px;
      margin-bottom: 10px;
      background-color: transparent;
      border-bottom: 1px solid #ddd;
      display: flex;
      align-items: center;
    }
    .title {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      padding-left: 8px;
      border-left: 4px solid #1890ff;
      margin-bottom: 40px;
      align-items: center;
    }
    .sporter_content {
      height: 600px;
      display: flex;
      justify-content: center;
      .leftBar {
        width: 45%;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        ::v-deep .select_pop_search {
          .el-input__inner {
            height: 32px;
            line-height: 32px;
            background-color: transparent !important;
            border: 0 !important;
            border-radius: 3px;
            color: #000 !important;
            padding: 0;
            text-indent: 35px;
          }
        }
      }
      .rightBar {
        width: 45%;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-left: 10px;
        .header {
          .flxL {
            font-size: 14px;
            color: #666;
            width: auto;
          }
          .flxR {
            font-size: 14px;
            color: #1890ff;
            padding: 0;
            width: auto;
          }
        }
        .selected_list {
          padding: 0 15px;
          .selected_item {
            padding: 8px 0;
            color: #fff;
          }
        }
      }
    }
  }
  .change_type_text {
    color: #fff;
    flex: 1;
    font-size: 12px;
    margin-left: 5px;
  }
}

.heightScroll {
  height: 536px !important;
  width: 100%;
  position: relative;
  display: inline-block;
  overflow-y: scroll;
  background: transparent;
}
.filter-tree ::v-deep .el-tree-node__expand-icon.is-leaf {
  width: 24px;
  height: 24px;
  &:before {
    content: '';
  }
}
.filter-tree {
  ::v-deep .el-tree-node__content > label.el-checkbox.is-disabled .el-checkbox__inner {
    background: #aaa;
  }
}

</style>
